import { COLORS, FONTS } from '../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  root: {
    fontFamily: FONTS.PRIMARY,
    fontWeight: 300,
    marginBottom: '10px',
  },
  inputRoot: {
    color: COLORS.GREY_DARK,
    fontSize: '1rem',
  },
  inputUnderline: {
    '&:before': {
      borderBottom: `2px solid ${COLORS.GREY}`,
    },
  },
  label: {
    fontWeight: 400,
    color: COLORS.GREY_DARK,
    fontSize: '1rem',
  },
  labelFocused: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  labelShrink: {
    fontWeight: 600,
    fontSize: '1rem',
    color: COLORS.GREY_DARKER,
    textTransform: 'uppercase',
  },
  tooltip: {
    backgroundColor: COLORS.GREEN,
    color: COLORS.WHITE,
  },
  errorTextStyle: {
    position: 'absolute',
    bottom: '-1.25rem',
  },
  startInputAdornmentRoot: {
    marginRight: 5,
    marginTop: -2,
    '& p': {
      color: COLORS.GREY_DARK,
    },
  },
});

export default styles;
